import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-help-tooltip',
    templateUrl: './help-tooltip.component.html',
    styleUrls: ['./help-tooltip.component.scss'],
    standalone: false
})
export class HelpTooltipComponent {
  @Input()
    public tooltipContent!: string;
}
